<script>
import ProgressBar from '@/components/atoms/ProgressBar.vue'
import allowanceBudget from '@/modules/mixins/allowanceBudget'

export default {
    components: { ProgressBar },
    mixins: [allowanceBudget],
    computed: {
        percent() {
            return Math.round((this.$cart.calculation.price_sum / this.biggerAllowance) * 100)
        },
    },
}
</script>
<template lang="pug">
.text-danger.mt-4(v-if="remainBudget > 0")
    .d-flex.align-items-center.pb-2
        icon(icon="fa-solid fa-tag").mr-2
        span.text-sm {{ $t('order.allowance_budget_progressbar.cart', {remaining_amount :  $options.filters.toCurrency(remainBudget) }) }}
    progress-bar(:sections="[1]" progress-color="bg-danger" :progress="[percent]" )
</template>
